import { useMutation } from '@tanstack/react-query';
import { GET, GET_WARRANTY_INFO_CODE } from '../../../../services';
import { useEffect, useState } from 'react';

export const useGetRegInfoEdit = ({ warrantyCode, reset, getValues }) => {
  const [data, setData] = useState();

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_WARRANTY_INFO_CODE(warrantyCode));
      return response.result;
    },
    onSuccess: (result) => {
      reset({
        ...getValues(),
        ...result?.warranty,
        invImageUrl: [{ uid: result?.warranty?.invImageUrl, url: result?.warranty?.invImageUrl }],
        packageImageUrl: [
          { uid: result?.warranty?.packageImageUrl, url: result?.warranty?.packageImageUrl },
        ],
      });
      setData(result);
    },
  });

  useEffect(() => {
    if (warrantyCode) {
      mutate();
    }
  }, [warrantyCode]);

  return { dataSource: data, setData, onSearch: mutate, loading: isPending };
};
